
export function formatString(value: any) {
  const removeVirgula = value?.split(',');
  const removeChave1 = removeVirgula?.map((item: any) => item.replace('{', ''));
  const removeChave2 = removeChave1?.map((item: any) => item.replace('}', ''));

  return removeChave2
}
